enum tableTypes {
  Initial_Filter = "Initial_Filter",
  Initial_Table = "Initial_Table",
  Handle_Filter = "Handle_Filter",
  Change_Filter = "Change_Filter",
  Handle_FilterTags = "Handle_FilterTags",
  Clear_FilterTags = "Clear_FilterTags",
  Clear_Filter = "Clear_Filter",
}

export default tableTypes;
